import { render } from "./wishlist-area.vue?vue&type=template&id=1c7ccc75&scoped=true"
import script from "./wishlist-area.vue?vue&type=script&lang=js"
export * from "./wishlist-area.vue?vue&type=script&lang=js"

import "./wishlist-area.vue?vue&type=style&index=0&id=1c7ccc75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7ccc75"]])

export default __exports__